import React from 'react';
import SubscriptionPlansWidget from './SubscriptionPlansWidget';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import OpenBillingPortalButton from './OpenBillingPortalButton';
import BillingPageContext from './BillingPageContext';
import BillingErrorMessage from './BillingErrorMessage';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { DeleteAccountButton } from 'features/tasks-forms';

export default function BillingPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Billing" />
      </SettingsBreadcrumbs>
      <BillingPageContext>
        <InnerBlock title="Billing" headerRight={<OpenBillingPortalButton />}>
          <BillingErrorMessage />
          <SubscriptionPlansWidget />
          <DeleteAccountButton />
        </InnerBlock>
      </BillingPageContext>
    </>
  );
}
